<template>
    <div class="tab-text">
        <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
                <span>Logo</span>
                <div style="font-size:0.75rem; color:#aaa;">
                    Recommended size: Height 64px. Width not more than 200px. 
                </div>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
                <div v-if="form.cologo != null">
                    <img
                        :src="form.cologo"
                        :width="imageWidth"
                        :height="imageHeight"
                    />
                </div>
                <div
                    v-if="!form.cologo"
                    class="default-upload"
                    style="width: 300px; height: 158px; background-color: #F5F5F5; border-radius: 8px; position: relative;"
                >
                    <vs-button
                        style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);"
                        color="dark"
                        type="border"
                        @click="chooseImage()"
                    >
                        <span>Upload</span>
                    </vs-button>
                </div>
                <div
                    class="grid-button-upload"
                    style="margin-top: 8px;
                            display: grid;
                            grid-template-columns: repeat(2, min-content);
                            grid-gap: 10px;"
                >
                    <!-- secondary / border  >> btn-->
                    <vs-button
                        v-if="form.cologo"
                        color="dark"
                        type="border"
                        icon="autorenew"
                        style="display: flex"
                        @click="chooseImage()"
                    >
                        <span>Change</span>
                    </vs-button>
                    <input
                        id="file-upload-img"
                        @change="onUploadImages()"
                        type="file"
                        ref="fileImage"
                        :accept="acceptFile"
                    >
                    <vs-button
                        v-if="form.cologo"
                        color="dark"
                        type="border"
                        icon="delete_forever"
                        style="display: flex"
                        @click="popupActivo=true"
                    >
                        Remove
                    </vs-button>
                    <vs-popup
                        classContent="popup-confirm"
                        title="Confirm Delete"
                        :active.sync="popupActivo"
                    >
                        <div>Are you sure you want to delete the image?</div>
                        <div class="wrap-button">
                        <vs-button
                            color="dark"
                            type="border"
                            style="font-size: 12px !important;"
                            @click="popupActivo=false"
                        >
                            No
                        </vs-button>
                        <vs-button
                            color="primary"
                            style="font-size: 12px !important;"
                            @click="removeBgImg()"
                        >
                            Yes
                        </vs-button>
                        </div>
                    </vs-popup>
                </div>
                <!-- <div> -->
                    <!-- <vs-upload
                        v-if="!uploadSeller"
                        :multiple="false"
                        :automatic="true"
                        :single-upload="true"
                        :action="posterUploadUrl"
                        :fileName="`cologo`"
                        :limit="1"
                        :data="posterData"
                        :headers="posterUploadHeader"
                        @on-success="successPosterUpload"
                    /> -->
                    <!-- <vs-upload
                        v-if="!form.cologo || changeImage"
                        :multiple="false"
                        :automatic="true"
                        :single-upload="true"
                        :fileName="`cologo`"
                        :limit="1"
                        @change="successLogoUpload"
                        @on-delete="deleteFileLogo"
                        accept="image/png, image/jpeg, image/jpg, image/webp"
                    /> -->
                <!-- </div> -->
                <!-- <div
                    class="grid-button-upload"
                    v-if="form.cologo || showBtn"
                >
                    <vs-button
                        color="dark"
                        type="flat"
                        icon="autorenew"
                        style="display: flex"
                        @click="changeBgImg()"
                    >
                        Change
                    </vs-button>
                    <vs-button
                        color="dark"
                        type="flat"
                        icon="delete_forever"
                        style="display: flex"
                        @click="removeBgImg()"
                    >
                        Remove
                    </vs-button>
                </div> -->
            </div>
        </div>
        <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
                <span>Name</span>
                <div style="font-size:0.75rem; color:#aaa;"></div>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
                <vs-input
                    class="w-full"
                    v-model="form.coname"
                    :maxLength="60"
                />
            </div>
        </div>
        <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
                <span>Address</span>
                <div style="font-size:0.75rem; color:#aaa;"></div>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
                <vs-textarea
                    style="display: block"
                    class="w-full"
                    v-model="form.address"
                />
            </div>
        </div>
        <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
                <span>Tax ID</span>
                <div style="font-size:0.75rem; color:#aaa;"></div>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
                <vs-input
                    v-validate="{ required: true, regex: /^[0-9]+$/, min: 13 }"
                    name="taxid"
                    :maxlength="20"
                    class="w-full"
                    v-model="form.taxid"
                    onkeypress="return /^[0-9]/i.test(event.key)"
                />
                <span class="text-danger text-sm" v-show="errors.has('taxid')">
                    {{ errors.first("taxid") }}
                </span>
            </div>
        </div>
        <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
                <span>Branch</span>
                <div style="font-size:0.75rem; color:#aaa;"></div>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
                <vs-input
                    class="w-full"
                    v-model="form.branch"
                />
            </div>
        </div>
        <div style="height:10px;"></div>
        <div class="vx-row pt-5 mt-5">
          <div class="vx-col w-full ml-auto">
            <vs-button class="mr-3 mb-2" @click="submitBasic">Submit</vs-button>
            <vs-button v-if="showSellerCancel" class="mr-3 mb-2" type="border" @click="canceled">Cancel </vs-button>
          </div>
        </div>
    </div>
</template>

<script>
import Service from "@/services";

import { timezones } from "@/utils/Timezones";

export default {
    props: [ 'form', 'e' ],
    data() {
        return {
            posterUploadUrl: process.env.VUE_APP_API_URL + "/events/" + this.$route.query.e + "/merchant/upload",
            posterUploadHeader: {
                Authorization:
                "Bearer " +
                JSON.parse(localStorage.getItem("soldoutt-nimda")).Auth.accessToken
            },
            posterData: {
                type: "poster"
            },
            timezones: timezones,
            showSellerCancel: false,
            uploadSeller: false,
            cologo: '',
            changeImage: false,
            showBtn: false,
            imageWidth: 0,
            imageHeight: 0,
            acceptFile: [
                'image/png',
                'image/jpeg',
                'image/jpg',
                'image/webp',
            ],
            popupActivo: false
        }
    },
    methods: {
        validateForm() {
            this.$validator.validateAll().then(result => {
                if (result) {
                // if form have no errors
                this.submitBasic();
                }
            });
        },
        submitBasic() {
            const path = this.$route.path.includes('/sellers/')
            this.$vs.loading();
            if (path) {
                this.form.cologo = this.cologo;
                this.$emit('submitBasic', this.form)
            }
            else {
                this.$vs.loading();
                const formData = new FormData();
                const dataKeyForms = Object.keys(this.form);
                for (let index = 0; index < dataKeyForms.length; index++) {
                    const key = dataKeyForms[index];
                    const value = this.form[key];
                    formData.append(key, value);
                }
                Service.Event.saveMerchant(formData, this.e)
                    .then(res => {
                        this.$vs.loading.close();
                        this.$vs.notify({
                            title: "Success",
                            text: "Update complete.",
                            color: "success"
                        });
                    })
                    .catch(e => {
                        this.$vs.loading.close();
                    });
            }
        },
        successPosterUpload(res) {
            Service.Event.get({ ...this.form, e: this.e })
            .then(res => {
                this.form = res.data.event.merchant;
                this.e = res.data.event.slug;
            })
            .catch(e => {
                /* this.$router.push("/pages/error-404").catch(() => {}); */
            });
            this.$vs.notify({
                color: "success",
                title: "Upload Success",
                text: "Poster upload success!"
            });
        },
        canceled() {
            this.$router.push('/sellers')
        },
        successLogoUpload(res, file) {
            this.cologo = file[0]
            this.changeImage = false
            this.showBtn = true
            this.updateBgImg()
        },
        updateBgImg() {
            this.form.cologo = this.cologo
            const merchantId = {
                id: this.$route.params.merchant_id
            }
            this.form.s = this.$route.query.s
            const formData = new FormData()
            const dataKeyForms = Object.keys(this.form);
                for (let index = 0; index < dataKeyForms.length; index++) {
                    const key = dataKeyForms[index];
                    const value = this.form[key]  === null ? '': this.form[key];
                    formData.append(key, value);
                }
            
                Service.Merchant.updateMerchant(formData, merchantId.id)
                .then(res => {
                    this.changeImage = false
                    this.form.cologo = res.data.cologo
                    // this.$vs.loading.close();
                    this.$vs.notify({
                        title: "Success",
                        text: "Update backgroung image complete.",
                        color: "success"
                    });
                })
                .catch(e => {
                    this.$vs.loading.close();
                });
        },
        changeBgImg() {
            this.changeImage = true
            this.showBtn = true
        },
        removeBgImg() {
            this.form.cologo = null
            const merchantId = {
                id: this.$route.params.merchant_id
            }
            this.form.s = this.$route.query.s
            const formData = new FormData()
            const dataKeyForms = Object.keys(this.form);
                for (let index = 0; index < dataKeyForms.length; index++) {
                    const key = dataKeyForms[index];
                    const value = this.form[key]  === null ? '': this.form[key];
                    formData.append(key, value);
                }
            formData.append('remove', 'cologo')
                Service.Merchant.updateMerchant(formData, merchantId.id)
                .then(res => {
                    this.changeImage = false
                    this.form.cologo = res.data.cologo
                    // this.$vs.loading.close();
                    this.$vs.notify({
                        title: "Success",
                        text: "Update backgroung image complete.",
                        color: "success"
                    });
                })
                .catch(e => {
                    this.$vs.loading.close();
                });
        },
        deleteFileLogo(res) {
            if (res) {
                this.form.cologo = null
            }
        },
        setImageSize () {
            let posterimage = document.querySelector('img')
            let w = posterimage.naturalWidth;
            let h = posterimage.naturalHeight;
            this.imageHeight = h
            this.imageWidth = w
            
            if (w > h) {
                this.imageWidth = 300
                this.imageHeight = 'auto'
            }
            else {
                this.imageHeight = 300
                this.imageWidth = 'auto'
            }
        },
        chooseImage() {
            document.getElementById("file-upload-img").click()
            },
            onUploadImages() {
                this.cologo = this.$refs.fileImage.files[0]
                this.form.cologo = this.$refs.fileImage.files[0]
                const reader = new FileReader()
                reader.onloadend = async() => {
                    this.form.cologo = reader.result
                    // this.posterUpdate = reader.result
                    this.setImageSize()
                    this.updateBgImg(this.cologo)
                }
                reader.readAsDataURL(this.$refs.fileImage.files[0])
                this.$refs.fileImage.value = null
            }
    },
    mounted() {
        this.setImageSize()
        this.showSellerCancel = this.$route.path.includes('/sellers/') ? true: false
        this.uploadSeller = this.$route.path.includes('/sellers/') ? true: false
    }
    
};
</script>
<style lang="scss" scoped>
  .grid-button-upload {
    margin-top: 8px;
    display: grid;
    grid-template-columns: repeat(2, min-content);
    grid-gap: 10px;
  }
  .vs-button {
    font-size: 10px !important;
  }
    input[type="file"] {
        display: none !important;
    }
    .popup-confirm {
        & div {
            width: 100%;
            text-align: center;
        }
        & .wrap-button {
            display: grid;
            grid-template-columns: repeat(2, 25%);
            grid-gap: 8px;
            justify-content: flex-end;
            margin-top: 20px;
        }
    }
  </style>
